export default __webpack_public_path__ + "static/media/IMG_7260-Edit.430eeaae.webp";